import { useState, type ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { creaQueryClient } from '@/api/queryClient';
import { AuthProvider } from '@/auth/AuthProvider';
import { FUTURE_ROUTER } from '@/navigation/navigation';
import { MeProvider } from '@/permisos/MeProvider';
import { RealtimeProvider } from '@/realtime/RealtimeProvider';
import { AppRoutes } from './router';

export function Proveidors({ children }: { children: ReactNode }) {
  const [queryClient] = useState(creaQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MeProvider>
          <RealtimeProvider>{children}</RealtimeProvider>
        </MeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default function App() {
  return (
    <Proveidors>
      <BrowserRouter future={FUTURE_ROUTER}>
        <AppRoutes />
      </BrowserRouter>
    </Proveidors>
  );
}
